module.exports = __webpack_public_path__ + "media/my_images/top/no.1-8fb61f171b9ed35f197a2081d6a22c8a.png";